import moment from 'moment';
import React from 'react';
import { useTranslate } from '../../mixins/translate/translate';
import { capitalizeFirstCharacter } from '../../utils/capitalizeFirstCharacter';
import {
    Content,
    EditPanel,
    EditPanelCell,
    EditPanelDatePicker,
    EditPanelInput,
    EditPanelRow,
    EditPanelSection,
    Panel,
    PanelBody,
    PanelButton,
    PanelLink,
    PanelTopHeading,
    Tray,
} from '../elements';

interface IFilterState {
    from?: string | undefined | null;
    to?: string | undefined | null;
    objectCode?: string;
    userEmail?: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const ExportAuditEvents: React.FC<Record<string, unknown>> = () => {
    const translate = useTranslate();
    const defaultFilterState: IFilterState = {
        from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
    };
    const [filterState, setFilterState] = React.useState<IFilterState>(defaultFilterState);

    const getUrl = (): string => {
        const baseUrl = '/api/auditevents/export';
        const params: string[] = Object.keys(filterState)
            .filter((key: string) => filterState[key as keyof IFilterState])
            .map((key: string) => `${key}=${filterState[key as keyof IFilterState]}`);
        return params.length ? `${baseUrl}?${params.join('&')}` : baseUrl;
    };

    return (
        <div className="export-audit-events">
            <Content>
                <Tray>
                    <Panel small={true} topBorder={true}>
                        <PanelTopHeading> Audit log</PanelTopHeading>
                        <PanelBody>
                            <EditPanel>
                                <EditPanelSection>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={3}>
                                            <EditPanelDatePicker
                                                name="from"
                                                value={filterState.from}
                                                topLabel={capitalizeFirstCharacter(translate('common.from'))}
                                                handleChange={(date) => setFilterState({ ...filterState, from: date })}
                                            />
                                        </EditPanelCell>
                                        <EditPanelCell rowCount={3}>
                                            <EditPanelDatePicker
                                                name="to"
                                                value={filterState.to}
                                                topLabel={capitalizeFirstCharacter(translate('common.to'))}
                                                handleChange={(to) => setFilterState({ ...filterState, to })}
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={6}>
                                            <EditPanelInput
                                                name="objectCode"
                                                topLabel={translate('object.objectCode')}
                                                value={filterState.objectCode}
                                                handleChange={(objectCode: string) => setFilterState({ ...filterState, objectCode })}
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={6}>
                                            <EditPanelInput
                                                name="userEmail"
                                                topLabel={`${translate('common.user')} ${translate('common.emailAddress')}`}
                                                value={filterState.userEmail}
                                                handleChange={(userEmail: string) => setFilterState({ ...filterState, userEmail })}
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                    <PanelButton text={translate('common.reset')} onClick={() => setFilterState(defaultFilterState)} small={true} />
                                    <PanelLink href={getUrl()} text="Export" primary={true} icon="fa fa-download" />
                                </EditPanelSection>
                            </EditPanel>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </div>
    );
};

ExportAuditEvents.displayName = 'ExportAuditEvents';

export { ExportAuditEvents };
